<template>
  <section class="rounded-3xl border border-gray-100 bg-white p-6 shadow-sm">
    <h2 class="text-lg font-semibold text-ink">Settings</h2>
    <p class="text-sm text-muted">Manage your account, preferences, and support.</p>

    <div class="mt-6 grid gap-4 md:grid-cols-2">
      <RouterLink
        v-for="item in accountItems"
        :key="item.label"
        :to="item.to"
        class="flex items-center justify-between gap-3 rounded-2xl border border-gray-100 bg-white px-4 py-4 text-left text-sm font-semibold text-ink shadow-sm transition hover:border-brand"
      >
        <span class="flex items-center gap-3">
          <span class="flex h-9 w-9 items-center justify-center rounded-xl bg-[#FFE5EC] text-brand">
            <i :class="item.icon"></i>
          </span>
          <span>{{ item.label }}</span>
        </span>
        <i class="ri-arrow-right-s-line text-lg text-muted"></i>
      </RouterLink>
    </div>

    <div class="my-8 h-px w-full bg-gray-100"></div>

    <div class="grid gap-4 md:grid-cols-2">
      <component
        v-for="item in supportItems"
        :key="item.label"
        :is="item.to ? RouterLink : 'button'"
        :to="item.to"
        type="button"
        class="flex items-center justify-between gap-3 rounded-2xl border border-gray-100 bg-white px-4 py-4 text-left text-sm font-semibold text-ink shadow-sm transition hover:border-brand"
        @click="item.action === 'logout' ? logout() : null"
      >
        <span class="flex items-center gap-3">
          <span class="flex h-9 w-9 items-center justify-center rounded-xl bg-[#FFE5EC] text-brand">
            <i :class="item.icon"></i>
          </span>
          <span>{{ item.label }}</span>
        </span>
        <i class="ri-arrow-right-s-line text-lg text-muted"></i>
      </component>
    </div>
  </section>
</template>

<script setup>
import { RouterLink, useRouter } from 'vue-router'
import Swal from 'sweetalert2'
import { clearAuth } from '@/services/auth'

const router = useRouter()

const accountItems = [
  { label: 'Profile', icon: 'ri-briefcase-line', to: '/dashboard/settings/profile' },
  { label: 'Change Password', icon: 'ri-lock-2-line', to: '/dashboard/settings/change-password' }
]

const supportItems = [
  { label: 'About Us', icon: 'ri-information-line', to: '/dashboard/settings/about' },
  { label: 'Support', icon: 'ri-customer-service-2-line', to: '/dashboard/settings/support' },
  { label: 'Faqs', icon: 'ri-question-line', to: '/dashboard/settings/faqs' },
  { label: 'Terms of Use', icon: 'ri-file-text-line', to: '/dashboard/settings/terms' },
  { label: 'Privacy Policy', icon: 'ri-shield-check-line', to: '/dashboard/settings/privacy' },
  { label: 'Logout', icon: 'ri-logout-box-r-line', action: 'logout' },
  { label: 'Delete Account', icon: 'ri-delete-bin-6-line' }
]

const logout = async () => {
  const result = await Swal.fire({
    title: 'Logout?',
    text: 'Your vendor session will be cleared on this device.',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#c73d3d',
    cancelButtonColor: '#8c7b6b',
    confirmButtonText: 'Logout',
    cancelButtonText: 'Cancel',
    reverseButtons: true
  })
  if (!result.isConfirmed) return
  clearAuth()
  router.push('/login?role=vendor')
}
</script>
